import React, { Dispatch, SetStateAction } from 'react';
import * as Table from '@ordermentum/ui-shared/components/Table';
import BigNumber from 'bignumber.js';
import { momentDateStamp } from '@ordermentum/ui-shared/utilities/date';
import Checkbox from '@ordermentum/ui-shared/components/Input/Checkbox';
import Button from '@ordermentum/ui-shared/components/Button/Button';
import { Invoice } from '@ordermentum/ui-types';
import { Icon } from '@ordermentum/ui-shared/foundations';

type Props = {
  invoices: Invoice[];
  retailerId: string;
  selectedInvoices: string[];
  setSelectedInvoices: Dispatch<SetStateAction<string[]>>;
};

const OutstandingInvoicesTable = ({
  invoices,
  retailerId,
  selectedInvoices,
  setSelectedInvoices,
}: Props) => (
  <Table.Table name="Outstanding Invoices">
    <Table.Head>
      <Table.HeadRow>
        <Table.HeadColumn width="5%">
          <Checkbox
            onChange={value => {
              if (!value) {
                setSelectedInvoices([]);
              } else {
                const allInvoices = invoices.map(invoice => invoice.id);
                setSelectedInvoices(allInvoices);
              }
            }}
          />
        </Table.HeadColumn>
        <Table.HeadColumn width="18%">Invoice number</Table.HeadColumn>
        <Table.HeadColumn width="18%">Supplier</Table.HeadColumn>
        <Table.HeadColumn width="15%">Invoice due</Table.HeadColumn>
        <Table.HeadColumn width="12%">Total</Table.HeadColumn>
        <Table.HeadColumn width="32%" />
      </Table.HeadRow>
    </Table.Head>
    <Table.Body>
      {invoices.map(({ id, number, supplier, dueAt, totalDue }) => (
        <Table.Row key={id}>
          <Table.Column width="5%">
            <Checkbox
              name={id}
              onChange={value => {
                if (!value) {
                  const newSelections = selectedInvoices.filter(
                    invoiceId => invoiceId !== id
                  );
                  setSelectedInvoices(newSelections);
                } else {
                  const updatedInvoices = Array.from(selectedInvoices);
                  updatedInvoices.push(id);
                  setSelectedInvoices(updatedInvoices);
                }
              }}
              checked={selectedInvoices.includes(id)}
            />
          </Table.Column>
          <Table.Column bold width="18%">
            {number}
          </Table.Column>
          <Table.Column width="18%">{supplier?.tradingName}</Table.Column>
          <Table.Column width="15%">{momentDateStamp(dueAt)}</Table.Column>
          <Table.Column width="12%">
            ${new BigNumber(totalDue).toFixed(2)}
          </Table.Column>
          <Table.Column width="32%">
            <Button
              as="a"
              variant="tertiary"
              icon={<Icon name="mDownload" inheritFill />}
              href={`/dashboard/${retailerId}/pay/${id}`}
            >
              View invoice
            </Button>
          </Table.Column>
        </Table.Row>
      ))}
    </Table.Body>
  </Table.Table>
);

export default OutstandingInvoicesTable;
